<template>
  <div class="content noHeader">
    <div @click="changePerson" v-if="$storage.get('patient')">
      <el-row style="height: 1rem;background-color: #fff;margin-bottom: .1rem;font-size: .3rem;">
        <el-col :span="8">
          <div style="height: 1rem;line-height: 1rem;margin-left: .3rem">当前就诊人：</div>
        </el-col>
        <el-col :span="13">
          <div style="height: 1rem;line-height: 1rem;">
            <span>{{$storage.get('patient').clinic_patient_name}}</span>
            <span style="float: right;color:#e02c06;font-weight: 700;font-size: .32rem">换人</span>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="height: 1rem;line-height: 1.3rem;padding-left: .1rem;">
            <img src="static/img/huanren.png" style="width: .5rem;height: .5rem"/>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-row style="width: 100%;height: .88rem;background-color: #ffffff;border-bottom: 1px #dddddd solid;" v-if="$storage.get('patient')">
      <el-col :span="11" style="height: 100%;line-height: .88rem;text-align: center">
        <div @click="openDrawer('date')">
          {{datePicker[datePickerIndex]}}
          <i style="font-weight: 800" class="el-icon-arrow-down"></i>
        </div>
        <el-drawer :visible.sync="dateDrawer" direction="btt" :show-close="false">
          <div class="drawer-section" v-for="(item,index) in datePicker" :key="index" @click="changeDate(index)">{{item}}</div>
          <div class="drawer-close" @click="dateDrawer=false">取消</div>
        </el-drawer>
      </el-col>
      <el-col :span="2" style="text-align: center;height: 100%;line-height: .88rem;font-size: .4rem">
        <div style="color: #aaaaaa">|</div>
      </el-col>
      <el-col :span="11" style="height: 100%;line-height: .88rem;text-align: center">
        <div @click="openDrawer('type')">
          {{typePicker[typePickerIndex]}}
          <i style="font-weight: 800" class="el-icon-arrow-down"></i>
        </div>
        <el-drawer :visible.sync="typeDrawer" direction="btt" :show-close="false">
          <div class="drawer-section" v-for="(item,index) in typePicker" :key="index" @click="changeType(index)">{{item}}</div>
          <div class="drawer-close" @click="typeDrawer=false">取消</div>
        </el-drawer>
      </el-col>
    </el-row>
    <div v-if="feeList.length>0" v-for="(item,index) in feeList" :key="index" @click="toDetails(item)">
      <el-row style="width: 100%;height: 1.2rem;background-color: #fff;border-bottom: 1px #f5f5f5 solid">
        <el-col :span="18" style="margin-left: .25rem">
          <div style="margin-top: .04rem;" :class="item.operate=='门诊缴费'?'cbule':''">{{item.operate}}</div>
          <div style="color: #999999">{{item.out_trade_no}}</div>
          <div style="color: #999999">{{item.paid_on_Str}}</div>
        </el-col>
        <el-col :span="4" style="text-align: right;position: relative">
          <div style="color: rgb(230, 162, 60);font-size: .32rem;height: .7rem;line-height: .8rem">￥{{item.amt}}</div>
          <div :class="item.refundable_state>0?'cred':'c999'">{{item.refundable_state>0?'有退款':item.status}}</div>
        </el-col>
      </el-row>
    </div>
    <div class="noCard" v-if="!feeList.length>0">
      <div class="noCard-img">
        <img src="static/img/noCard.png"/>
      </div>
      <div class="noCard-text">暂无缴费记录</div>
    </div>
  </div>
</template>

<script>
  import {GetFee} from '../../api/index'
    export default {
      data(){
        return{
          feeList:[],
          datePicker:['一周','一个月','半年','一年内','时间不限'],
          datePickerIndex:4,
          dateDrawer:false,
          typePicker:['门诊缴费','住院押金缴费'],//,'体检缴费'
          typePickerIndex:0,
          typeDrawer:false,
        }
      },
      created() {
        this.typePickerIndex = this.$route.query.index?this.$route.query.index:this.typePickerIndex
        //修改标题
        document.title = '缴费记录'
        if(this.$storage.get('patient')){
          this.getList()
        }
      },
      methods:{
        getList(){
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          GetFee({
            healthId:this.$storage.get('patient').healthCardId,
            openid:this.$storage.get('openid'),
            unionid:this.$storage.get('unionid'),
            feetype:this.typePickerIndex+1,
            timetype:this.datePickerIndex+1
          }).then(res=>{
            loading.close();
            res.Data.forEach(e=>{
              switch (e.status) {
                case 0:
                  e.status = '交易中'
                  break
                case 1:
                  e.status = '交易成功'
                  break
                case 2:
                  e.status = '交易失败'
                  break
                case 3:
                  e.status = '退款中'
                  break
                case 4:
                  e.status = '退款失败'
                  break
                case 5:
                  e.status = '退款成功'
                  break
              }
            })
            this.feeList = res.Data
          })
        },
        // 打开Drawer抽屉
        openDrawer(query){
          if(query=='date'){
            this.dateDrawer = true
          }else if(query=='type'){
            this.typeDrawer = true
          }
        },
        // 切换时间筛选
        changeDate(index){
          this.datePickerIndex = index
          this.getList()
          this.dateDrawer = false
        },
        // 切换支付类型筛选
        changeType(index){
          this.typePickerIndex = index
          this.getList()
          this.typeDrawer = false
        },
        toDetails(item){
          if(item.operate=='门诊缴费'){
            this.$router.push({path:'/payRecordDetails',query:{id:item.id}})
          }
        },
        //换人
        changePerson(){
          this.$router.push({path:'/selectPerson'})
        },
      }
    }
</script>

<style scoped>
  .content{
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
    font-size: .28rem;
  }
  /*清除点击Drawer自带边框*/
  /deep/ :focus {
    outline: 0;
  }
  .drawer-section{
    height: .8rem;
    text-align: center;
    font-size: .3rem;
    line-height: .8rem;
    border-bottom: 1px #dddddd solid;
  }
  .drawer-close{
    height: .9rem;
    border-top: .05rem #dddddd solid;
    font-size: .3rem;
    text-align: center;
    line-height: .9rem;
  }
  .noCard{
    width: 7.5rem;
    height: 3.5rem;
    padding: 2rem 0 4rem 0;
    background-color: #ffffff;
  }
  .noCard .noCard-img{
    width: 2.6rem;
    height: 2.6rem;
    margin: 0 auto;
  }
  .noCard .noCard-img img{
    width: 100%;
    height: 100%;
  }
  .noCard .noCard-text{
    margin-top: .3rem;
    font-size: .32rem;
    line-height: .32rem;
    width: 100%;
    height: .32rem;
    text-align: center;
    color: #999999;
  }
  .cred{
    color: red;
  }
  .c999{
    color: #999999;
  }
  .cbule{
    color: #409eff;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/payRecord.vue